import { COLOR_MAP, COLOR_PALETTES } from 'constants/appStyling/options';

export default function getHighlightProps({ color, paletteId }) {
  const paletteColors = COLOR_PALETTES[paletteId];
  const highlightColor = color ? paletteColors[COLOR_MAP[color]] : null;

  return highlightColor;
}
